import { useEffect, useMemo, useState } from "react";

const isStandaloneMode = () => {
  if (typeof window === "undefined") return false;

  return (
    window.matchMedia?.("(display-mode: standalone)")?.matches ||
    window.navigator?.standalone === true
  );
};

export default function PwaInstallPrompt() {
  const [installPromptEvent, setInstallPromptEvent] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(() => {
    try {
      return localStorage.getItem("pwaInstallPromptDismissed") === "true";
    } catch {
      return false;
    }
  });

  const shouldRender = useMemo(
    () => isVisible && installPromptEvent && !isDismissed && !isStandaloneMode(),
    [installPromptEvent, isDismissed, isVisible]
  );

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallPromptEvent(event);
      setIsVisible(true);
    };

    const handleAppInstalled = () => {
      setInstallPromptEvent(null);
      setIsVisible(false);
      setIsDismissed(true);
      try {
        localStorage.setItem("pwaInstallPromptDismissed", "true");
      } catch {
        // localStorage kapalıysa sadece bu oturumda gizlenir.
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const installApp = async () => {
    if (!installPromptEvent) return;

    installPromptEvent.prompt();
    await installPromptEvent.userChoice.catch(() => null);
    setInstallPromptEvent(null);
    setIsVisible(false);
  };

  const dismissPrompt = () => {
    setIsDismissed(true);
    setIsVisible(false);
    try {
      localStorage.setItem("pwaInstallPromptDismissed", "true");
    } catch {
      // localStorage kapalıysa sadece bu oturumda gizlenir.
    }
  };

  if (!shouldRender) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: 18,
        bottom: 18,
        zIndex: 2100,
        width: 330,
        maxWidth: "calc(100vw - 36px)",
        borderRadius: 18,
        padding: 14,
        background: "#ffffff",
        color: "#124254",
        border: "1px solid #dbe2ea",
        boxShadow: "0 20px 44px rgba(15,23,42,0.22)"
      }}
    >
      <div style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
        <div
          style={{
            width: 38,
            height: 38,
            borderRadius: 12,
            background: "#e0f2fe",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 20,
            flex: "0 0 auto"
          }}
        >
          📱
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 950 }}>
            Argevio’yu uygulama gibi kullan
          </div>
          <div style={{ marginTop: 4, fontSize: 12, lineHeight: 1.4, color: "#64748b", fontWeight: 700 }}>
            Ana ekrana ekleyip tam ekran ve daha hızlı erişimle açabilirsiniz.
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 12 }}>
        <button
          type="button"
          onClick={dismissPrompt}
          style={{
            border: "1px solid #dbe2ea",
            borderRadius: 10,
            background: "#f8fafc",
            color: "#475569",
            padding: "9px 11px",
            fontWeight: 900,
            cursor: "pointer"
          }}
        >
          Daha sonra
        </button>
        <button
          type="button"
          onClick={installApp}
          style={{
            border: "none",
            borderRadius: 10,
            background: "#124254",
            color: "#fff",
            padding: "9px 13px",
            fontWeight: 950,
            cursor: "pointer"
          }}
        >
          Yükle
        </button>
      </div>
    </div>
  );
}
